"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20.05 2.41 18.64 1c-3.51 3.51-3.51 9.21 0 12.73l1.41-1.41c-2.73-2.74-2.73-7.18 0-9.91"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m22.88 5.24-1.41-1.41c-1.95 1.95-1.95 5.12 0 7.07l1.41-1.41c-1.17-1.17-1.17-3.08 0-4.25"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M15.48 17.34C14.29 16.73 12.37 16 10 16s-4.29.73-5.48 1.34c-.32.16-.52.5-.52.88V19h12v-.78c0-.38-.2-.72-.52-.88",
  opacity: ".3"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "9",
  r: "2",
  opacity: ".3"
}, "3"), /*#__PURE__*/_jsx("path", {
  d: "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m6.39 8.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56C2.61 16.07 2 17.1 2 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66M16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16s4.29.73 5.48 1.34c.32.16.52.5.52.88z"
}, "4")], 'SpatialTrackingTwoTone');